import React from 'react'
import styled, { css, keyframes } from 'styled-components'

const pulse = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
`

const animation =
  (delay = 0) =>
  () =>
    css`
      ${pulse} 2s infinite ${delay}s;
    `

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  margin: -10px -30px -30px;
  z-index: 1;

  .loading-content {
    width: 150px;
    height: 150px;
    line-height: 150px;
    margin: 100px auto;
    position: relative;
    box-sizing: border-box;
    text-align: center;
    z-index: 0;
    text-transform: uppercase;

    :before,
    :after {
      opacity: 0;
      box-sizing: border-box;
      position: absolute;
      content: '\\0020';
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 100px;
      border: 5px solid #022c5f;
      box-shadow: 0 0 50px #022c5f, inset 0 0 50px #022c5f;
    }

    :after {
      z-index: 1;
      animation: ${animation(1)};
    }

    :before {
      z-index: 2;
      animation: ${animation()};
    }
  }
`

const LoginLoader = ({ loading }) =>
  loading ? (
    <Wrapper>
      <div className="loading-content" />
    </Wrapper>
  ) : null

export default LoginLoader
